import { render, staticRenderFns } from "./matcateryDialog.vue?vue&type=template&id=3facd519&scoped=true&"
import script from "./matcateryDialog.vue?vue&type=script&lang=js&"
export * from "./matcateryDialog.vue?vue&type=script&lang=js&"
import style0 from "./matcateryDialog.vue?vue&type=style&index=0&id=3facd519&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3facd519",
  null
  
)

export default component.exports